import { EditorApp } from './features/editor/EditorApp';

export function App() {
  return <EditorApp />;
}
